import React from 'react';
import IconWrapper from '../IconWrapper';
const PinOutlineIcon = (props) => {
    const brand = process.env.BRAND || process.env.BRAND_PREFIX;
    switch (brand) {
        case 'cos':
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("g", { fill: "none", fillRule: "evenodd" },
                    React.createElement("path", { fill: "#FFF", d: "M0 0h24v24H0z" }),
                    React.createElement("path", { d: "M0 0h24v24H0z" }),
                    React.createElement("path", { d: "M12 2C8.13 2 5 4.973 5 8.65 5 13.637 12 21 12 21s7-7.363 7-12.35C19 4.973 15.87 2 12 2Zm0 9.025c-1.38 0-2.5-1.064-2.5-2.375s1.12-2.375 2.5-2.375 2.5 1.064 2.5 2.375-1.12 2.375-2.5 2.375Z", stroke: "#1B1B1B", strokeWidth: ".8" }))));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M11.97 0c4.863 0 9 4.15 9 8.824 0 1.198-.266 2.34-.792 3.397-1.68 3.374-5.026 8.06-7.84 11.125l-.368.401-.368-.401c-2.813-3.063-6.16-7.75-7.84-11.125a7.558 7.558 0 01-.792-3.398C2.97 4.15 7.107 0 11.97 0zm0 1c-4.31 0-8 3.701-8 7.823 0 1.044.23 2.034.687 2.952 1.563 3.14 4.64 7.491 7.313 10.488 2.673-2.998 5.75-7.349 7.313-10.488a6.555 6.555 0 00.687-2.951C19.97 4.7 16.28 1 11.97 1zm0 4a4 4 0 110 8 4 4 0 010-8zm0 1a3 3 0 100 6 3 3 0 000-6z" })));
    }
};
export default PinOutlineIcon;
//# sourceMappingURL=PinOutlineIcon.js.map